import { getReports } from "../../../root.selectors";
import { FormattedBarChartStoreSlice } from "./barchart.types";
import { createSelector } from "reselect";
import { ReportsState } from "../../reports.types";

export const getBarchartReports = createSelector(
  [getReports],
  (reportsSlice: ReportsState): FormattedBarChartStoreSlice[] =>
    reportsSlice.barchart.data
);

export const isBarchartLoading = createSelector(
  [getReports],
  (reportsSlice: ReportsState): boolean => reportsSlice.barchart.isLoading
);

export const isBarchartLoadFailed = createSelector(
  [getReports],
  (reportsSlice: ReportsState): boolean => !!reportsSlice.barchart.error
);

export const isBarchartLoadSuccessful = createSelector(
  [getReports],
  (reportsSlice: ReportsState): boolean => reportsSlice.barchart.success
);
